<template>
  <div class="app flex-row align-items-center">
    <div class="container" v-if="showlogin">
      <b-row>
        <b-col md="5">
          <b-card-group>
            <b-card no-body class="p-4">
              <img :src="enac ? 'img/logo_enac.png' : (green ? 'img/logo_green.png' : 'img/logo-small.png')" alt="Logo" class="logo" />
              <b-card-body>
                <b-form>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="text"
                      v-model="user"
                      class="form-control"
                      placeholder="Username"
                      autocomplete="username"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      v-model="pw"
                      class="form-control"
                      placeholder="Password"
                      autocomplete="current-password"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <label class="anno" for="anno" :label-cols="3">Anno</label>
                    <b-form-select v-model="anno" id="anno" :plain="true" :options="anni"></b-form-select>
                  </b-input-group>
                  <b-form-checkbox-group id="rememberme">
                    <!-- stacked -->
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="customChk1"
                        v-model="rememberme"
                        checked
                      />
                      <label class="custom-control-label" for="customChk1">Ricordami</label>
                    </div>
                  </b-form-checkbox-group>
                  <br />
                  <b-button
                    type="submit"
                    variant="primary"
                    class="px-12"
                    @click="handleSubmit"
                  >Login</b-button>
                </b-form>
                <br>
                <span class=version>{{version}}</span>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
        <b-col md="7">
          <div :class="enac ? 'bgimageenac' : (green ? 'greenbg' : 'bgimage')"></div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
const curranno = 25;

var CryptoJS = require("crypto-js");
import { API } from "@/api.js";

export default {
  name: "Login",
  data() {
    console.log("RUN MODE 2:", process.env.NODE_ENV); // development ?
    var url = new URL(window.location.href);
    var app = url.searchParams.get("app");

    var sl = true;
    if (app) sl = false;

    var user = localStorage.getItem("user");
    var pw = localStorage.getItem("pw");
    if (user && user != "false")
      user = CryptoJS.AES.decrypt(user, window.secret).toString(CryptoJS.enc.Utf8);
    if (pw && pw != "false")
      pw = CryptoJS.AES.decrypt(pw, window.secret).toString(CryptoJS.enc.Utf8);
    return {
      user: user,
      pw: pw,
      anno: curranno,
      rememberme: localStorage.getItem("remme"),
      showlogin: sl
    };
  },
  created: async function() {
    if (this.view) {
      // chiamato da swone, prendo il token
      //sessionStorage.setItem(window.keyname, null);
      console.log("LGET2:", window.location.origin + "/getToken.php?rnd=???");
      var ret = await this.$http.get(
        window.location.origin + "/getToken.php?rnd=" + Math.random()
      );
      console.log("LRET:", ret);
      sessionStorage.setItem(window.keyname, ret.data);
      // non l'ha fatto nel main, lo fa qui

      await API.getpars(this)
      // await this.$http.get(window.baseurl + "/getpars").then(ps => {
      //   console.log("GETPARS:", ps.data.dati);
      //   ps.data.dati.map(p => {
      //     window[p.nome] = p.valore;
      //     console.log(p.nome + " = " + p.valore);
      //   });
      // });
      this.$router.push("/");
    }
  },
  computed: {
    enac() {
      return window.ENAC
    },
    green() {
      return window.GREEN
    },
    version(){
      return window.VERSION
    },
    view() {
      var url = new URL(window.location.href);
      var app = url.searchParams.get("app");
      console.log("URLAPP:", url, app, window.location);
      return app;
    },
    anni() {
      let ret = [];
      if(this.green) {
        for (let a = curranno; a >= 22; a--) {
            let a1 = 2000 + a;
            ret.push({ value: a, text: a1});
        }
      } else {
        for (let a = curranno - 1; a >= 6; a--) {
            let a1 = 2000 + a;
            let a2 = ("00" + (a + 1)).slice(-2);
            ret.push({ value: a + 1, text: a1 + "/" + a2 });
        }
    }
      return ret;
    }
  },
  mixins: [window.myMixin],
  methods: {
    handleSubmit(e) {
      var me = this;
      e.preventDefault();
      if (this.pw.length > 0) {
        let url = window.baseurl + "/logintoken";
        this.$http
          .post(url, {
            user: this.user,
            password: this.pw,
            anno: this.anno,
            token: true
          })
          .then(async response => {
            if (response.data.TOKEN) {
              localStorage.setItem("remme", me.rememberme);
              if (me.rememberme) {
                localStorage.setItem(
                  "user",
                  CryptoJS.AES.encrypt(me.user, window.secret).toString()
                );
                localStorage.setItem(
                  "pw",
                  CryptoJS.AES.encrypt(me.pw, window.secret).toString()
                );
              } else {
                localStorage.setItem("user", "false");
                localStorage.setItem("pw", "false");
              }

              sessionStorage.setItem(window.keyname, response.data.TOKEN);
              console.log("QUI1")
              await API.getpars(me)
              // let ps = await me.$http.get(window.baseurl + "/getpars");
              // console.log("GETPARS:", ps.data.dati);
              // ps.data.dati.map(p => {
              //   window[p.nome] = p.valore;
              //   console.log(p.nome + " = " + p.valore);
              // });
              var td = me.getTokenData()
              console.log("GETPARS",td)
              if(td.sub.guest && td.sub.guest.annualita=='5' && td.sub.schema=="a2020"){
                window.FORMVOTIALUNNI_DATAFINESEM = '2020-02-28'
                console.log("Cambio data fine sem")
              }

              if (this.$route.params.nextUrl != null) {
                this.$router.push(this.$route.params.nextUrl);
              } else {
                this.$router.push("/");
              }
              /*
              this.$http.get(window.baseurl+"/test",{params: {a: 124, b: "pippo"}})
                .then( response => console.log(response))
                .catch( err => console.log("ERR!",err))
              */
            } else {
              sessionStorage.setItem(window.keyname, "null");
            }
          })
          .catch(function(error) {
            console.error(error);
            sessionStorage.setItem(window.keyname, "null");
          });
      }
    }
  }
};
</script>
<style scoped>
span.version {
  font-size: xx-small;
}
label.anno {
  padding-right: 10px;
}
div.rememberme label {
  bottom: 10px;
}
img.logo {
  width: 128px;
  margin: auto;
}
div.bgimage {
  background-image: url("../../../public/img/login-bg.jpg");
  height: 100%;
  background-size: cover;
  background-position: top;
}
div.greenbg {
  background-image: url("../../../public/img/greenbg.jpg");
  height: 100%;
  background-size: cover;
  background-position: top;
}
div.bgimageenac {
  background-image: url("../../../public/img/enacbg.jpg");
  height: 100%;
  background-size: cover;
  background-position: top;
}
</style>
<style>
.custom-control-label {
  vertical-align: inherit;
}
</style>